import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements AfterViewInit {
  @Input() parentName: string;
  @Input() name: string;
  @Input() master: string;

  constructor(
    private titleService: Title,
  ) { }

  ngAfterViewInit(): void {
    this.titleService.setTitle(this.parentName + ' > ' + this.name + ' :: ASF System');
  }

}
